(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope) {
    scope.querySelectorAll('.sweet-footer:not([data-footer-ready])').forEach(footer => {
      footer.dataset.footerReady = 'true';
      if (reduce.matches || !('IntersectionObserver' in window)) return;
      footer.classList.add('footer-motion');
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        footer.classList.add('is-visible');
        observer.disconnect();
      }, {rootMargin:'0px 0px -20px 0px'});
      observer.observe(footer);
      reduce.addEventListener('change', () => {
        if (reduce.matches) {footer.classList.remove('footer-motion');observer.disconnect();}
      }, {once:true});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
